<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectOneInput
        :question="$t('stage.question')"
        :image="require('@/assets/planning.jpeg')"
        :selections="[
          {  name: $t('stage.land'),  value: 'land' },
          {  name: $t('stage.idea'),  value: 'idea' },
          {  name: $t('stage.permit'),  value: 'permit' },
          {  name: $t('stage.plan'),  value: 'plan' },
          {  name: $t('stage.construction'),  value: 'construction' },
          {  name: $t('stage.electrical'),  value: 'electrical' },
          {  name: $t('stage.renovating'),  value: 'renovating' },
          {  name: $t('stage.other'),  value: 'other' },
        ]"
        :selected-value="selected"
        :clicked-callback="onSelect"
      ></SelectOneInput>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
      >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
  import SelectOneInput from "../../components/SelectOneInput";
  import {mapMutations} from "vuex";
  import CalculatorHeading from "../../components/CalculatorHeading";
  import {getStepIndex} from "@/utils/steps.js";
  import {getPrevStepUrl, goToNextStep, redirectToUnselectedStepIfAny} from "../../utils/steps";

  export default {
  name: "ProjectStage",
  components: { CalculatorHeading, SelectOneInput },
  data() {
    return {
      step: getStepIndex("stage"),
      getPrevStepUrl: getPrevStepUrl,
      selected: this.$store.state.data.stage
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateStage"]),
    onSelect(value) {
      this.selected = value;
      this.updateStage(value);
      goToNextStep(this.step, this.$i18n.locale, this.$router);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/_variables.scss";
h4 {
  color: $color-primary;
}
.back-btn {
  margin-top: 60px;
}
</style>
